import React, { useState, useEffect, useRef } from 'react';
import './room1.css';
import './room2.css';
import './room2task3.css';

import Settings from '../components/common/settings';
import Lost from '../components/common/lost';
import Won from '../components/common/won';
import { useNavigate } from 'react-router-dom';

import lockedSound from '../audios/mixkit-click-error-1110.wav';
import settingsSound from '../audios/settoings.wav';

const TOTAL_TIME = 10 * 60;
const ROOM_KEY = 'room2_time'; 

const Room2task4 = () => {
  const navigate = useNavigate();

  const [timeLeft, setTimeLeft] = useState(TOTAL_TIME);
  const [openSettings, setOpenSettings] = useState(false);
  const [showLosePopup, setShowLosePopup] = useState(false);
  const [showWonPopup, setShowWonPopup] = useState(false);

  const [showKeypad, setShowKeypad] = useState(false);
  const [keypadInput, setKeypadInput] = useState('');
  const [keypadError, setKeypadError] = useState(false);

  const lockedAudio = useRef(null);
  const settingsAudio = useRef(null);

  useEffect(() => {
    lockedAudio.current = new Audio(lockedSound);
    settingsAudio.current = new Audio(settingsSound);
  }, []);

  // reads the same room2_time key that Room2.jsx set — never resets it here,
  // so the countdown keeps running across the whole Room 2 → ... → here chain
  useEffect(() => {
    const interval = setInterval(() => {
      const saved = localStorage.getItem(ROOM_KEY);

      if (!saved) return;

      const elapsed = Math.floor(
        (Date.now() - Number(saved)) / 1000
      );

      const remaining = Math.max(
        TOTAL_TIME - elapsed,
        0
      );

      setTimeLeft(remaining);

      if (remaining === 0) {
        setShowLosePopup(true);
        clearInterval(interval);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const playSettingsSound = () => {
    if (!settingsAudio.current) return;

    settingsAudio.current.currentTime = 0;
    settingsAudio.current.play().catch(() => {});
  };

  const openSettingsMenu = () => {
    playSettingsSound();
    setOpenSettings(true);
  };

  const closeSettingsMenu = () => {
    playSettingsSound();
    setOpenSettings(false);
  };

  const handleKeypadPress = (val) => {
    if (keypadInput.length >= 4) return;

    const next = keypadInput + val;

    setKeypadInput(next);
    setKeypadError(false);

    if (next.length === 4) {
      if (next === '5321') {
        setTimeout(() => {
          setShowKeypad(false);
          setShowWonPopup(true);
        }, 400);
      } else {
        setKeypadError(true);

        lockedAudio.current?.play().catch(() => {});

        setTimeout(() => {
          setKeypadInput('');
          setKeypadError(false);
        }, 800);
      }
    }
  };

  const handleKeypadClear = () => {
    setKeypadInput('');
    setKeypadError(false);
  };

  const minutes = String(
    Math.floor(timeLeft / 60)
  ).padStart(2, '0');

  const seconds = String(
    timeLeft % 60
  ).padStart(2, '0');

  const isWarning = timeLeft <= 60;
  const fillPercent = (timeLeft / TOTAL_TIME) * 100;

  return (
    <section className="room2div">

      <div
        className="room2task4"
        onClick={() => setShowKeypad(true)}
      />

      <div className="room1nav">
        <div />

        <div className="roomtimer">
          <span className="timerlabel">
            TIME REMAINING
          </span>

          <div className="timerdiv">
            <span
              className={`timerdigits ${
                isWarning ? 'timerwarning' : ''
              }`}
            >
              {minutes}:{seconds}
            </span>
          </div>

          <div className="timerbar">
            <div
              className="timerbartill"
              style={{
                width: `${fillPercent}%`,
                background: isWarning
                  ? '#ff4444'
                  : '#D4AF37',
              }}
            />
          </div>
        </div>

        <div
          className="settings"
          onClick={openSettingsMenu}
        />
      </div>

      {showKeypad && (
        <div
          className="keypadoverlay"
          onClick={() => setShowKeypad(false)}
        >
          <div
            className="keypadmodal"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="keypadtitle">
              ENTER CODE
            </div>

            <div
              className={`keypadscreen ${
                keypadError ? 'keypaderr' : ''
              }`}
            >
              {'●'
                .repeat(keypadInput.length)
                .padEnd(4, '○')}
            </div>

            <div className="keypadgrid">
              {[
                '1', '2', '3',
                '4', '5', '6',
                '7', '8', '9',
                'C', '0', '⌫'
              ].map((k) => (
                <button
                  key={k}
                  className={`keypadbtn ${
                    k === 'C'
                      ? 'keypadclear'
                      : ''
                  }`}
                  onClick={() => {
                    if (k === 'C') {
                      handleKeypadClear();
                    } else if (k === '⌫') {
                      setKeypadInput((p) =>
                        p.slice(0, -1)
                      );
                    } else {
                      handleKeypadPress(k);
                    }
                  }}
                >
                  {k}
                </button>
              ))}
            </div>

            <button
              className="keypadclose"
              onClick={() => setShowKeypad(false)}
            >
              ✕
            </button>
          </div>
        </div>
      )}

      <Settings
        open={openSettings}
        onClose={closeSettingsMenu}
        onPlaySound={playSettingsSound}
        onNavigate={navigate}
      />

      <Lost
        open={showLosePopup}
        onRetry={() => {
          localStorage.removeItem(ROOM_KEY);
          window.location.reload();
        }}
      />

      {showWonPopup && (
        <Won
          onReplay={() => navigate('/room2')}
          chooseRoomPath="/levels3"
        />
      )}

    </section>
  );
};

export default Room2task4;